
import React, { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { useForm } from "@/context/FormContext";
import { FormFieldType } from "@/types/form";
import FieldWrapper from "./FieldWrapper";

interface TextFieldProps {
  element: FormFieldType;
}

export const TextField: React.FC<TextFieldProps> = ({ element }) => {
  const { formData, setField } = useForm();
  const [isDisabled, setIsDisabled] = useState(element.readOnly || false);
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setField(element.name!, e.target.value);
  };

  // This effect makes the field respond to external changes to its disabled state
  useEffect(() => {
    const checkDisabledStatus = () => {
      const fieldElement = document.getElementById(element.id) as HTMLInputElement;
      if (fieldElement) {
        setIsDisabled(fieldElement.disabled || fieldElement.readOnly || false);
      }
    };

    // Initial check
    checkDisabledStatus();

    // Set up a mutation observer to detect changes to the disabled attribute
    const observer = new MutationObserver(checkDisabledStatus);
    const fieldElement = document.getElementById(element.id);
    
    if (fieldElement) {
      observer.observe(fieldElement, { 
        attributes: true, 
        attributeFilter: ['disabled', 'readonly'] 
      });
    }

    return () => {
      observer.disconnect();
    };
  }, [element.id]);

  return (
    <FieldWrapper element={element}>
      <Input
        id={element.id}
        placeholder={element.placeholder || ""}
        value={(formData[element.name!] as string) || ""}
        onChange={handleChange}
        className={`w-full ${isDisabled ? "bg-gray-100" : ""}`}
        required={element.required}
        readOnly={element.readOnly}
      />
    </FieldWrapper>
  );
};

export default TextField;
